import { jsx } from 'react/jsx-runtime';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import 'react';
import { useTreeContent } from '../../hooks/useTree/useTreeContent.js';
import '../../hooks/useTree/useTreeController.js';
import { Loader } from '../Loader/Loader.js';
import { SidebarNavigationItem } from './SidebarNavigationItem.js';
import { SidebarNavigationPrimary } from './SidebarNavigationPrimary.js';

const SidebarNavigation = /*#__PURE__*/withTitan(({
  matchFunction,
  selectedDepth,
  isSelecting,
  onClickLink,
  onClickButton,
  onHideDrawer,
  onCloseSubMenu,
  testId = 'sidebarNavigation'
}) => {
  const tree = useTreeContent();
  if (tree.isLoading) {
    return jsx(Loader, {
      height: 68
    });
  }
  return jsx(SidebarNavigationPrimary, {
    selectedDepth: selectedDepth,
    children: tree.items.map(item => jsx(SidebarNavigationItem, {
      isSelecting: isSelecting,
      item: item,
      matchFunction: matchFunction,
      selectedDepth: selectedDepth,
      testId: `${testId}Item`,
      onClickButton: onClickButton,
      onClickLink: onClickLink,
      onCloseSubMenu: onCloseSubMenu,
      onHideDrawer: onHideDrawer
    }, `sidebar-child-${item.id}`))
  });
}, {
  name: 'SidebarNavigation'
});

export { SidebarNavigation };
//# sourceMappingURL=SidebarNavigation.js.map
